import { INFINITY_CAROUSEL_VIRTUAL_SLIDES_COUNT } from 'modules/leaderboards/constants';
import React, { createContext, Dispatch, FC, SetStateAction, useCallback, useState } from 'react';
import Carousel from 'react-multi-carousel';

interface CarouselContextProps {
  activeSlide: number;
  setActiveSlide: Dispatch<SetStateAction<number>>;
  previous: () => void;
  next: () => void;
}

interface CarouselProviderProps {
  carousel?: Carousel | null;
}

export const CarouselContext = createContext<CarouselContextProps>({
  activeSlide: 0,
  setActiveSlide: () => {},
  next: () => {},
  previous: () => {},
});

export const CarouselProvider: FC<CarouselProviderProps> = ({ carousel, children }) => {
  const [activeSlide, setActiveSlide] = useState<number>(INFINITY_CAROUSEL_VIRTUAL_SLIDES_COUNT);

  const next = useCallback(() => {
    if (!carousel) {
      return;
    }

    carousel.next(1);
  }, [carousel]);

  const previous = useCallback(() => {
    if (!carousel) {
      return;
    }

    carousel.previous(1);
  }, [carousel]);

  return (
    <CarouselContext.Provider value={{ activeSlide, setActiveSlide, next, previous }}>
      {children}
    </CarouselContext.Provider>
  );
};
